var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.775 7.76995L39.6825 7.98578L30.7408 28.7366H21.9533C19.8567 28.7366 17.8525 29.1683 16.0333 29.9391L21.4292 17.0508L21.5525 16.7424L21.7683 16.2491C21.83 16.0641 21.8917 15.8791 21.9842 15.7249C26.0233 6.38245 30.5867 4.25495 39.775 7.76995Z",
    stroke: "#00DA71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3942 29.3534C55.0067 28.9217 53.5267 28.7367 52.0467 28.7367H30.7408L39.6825 7.98585L39.775 7.77002C40.2375 7.92419 40.6692 8.14002 41.1317 8.32502L47.9458 11.1925C51.7383 12.765 54.39 14.3992 55.9933 16.3725C56.3017 16.7425 56.5483 17.0817 56.7642 17.4825C57.0417 17.9142 57.2575 18.3459 57.3808 18.8084C57.5042 19.0859 57.5967 19.3634 57.6583 19.61C58.4908 22.2 57.9975 25.3759 56.3942 29.3534Z",
    stroke: "#00DA71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67.8334H24.975C24.235 67.8334 23.495 67.7717 22.7858 67.6792C12.9808 67.0317 7.73917 61.79 7.09167 51.985C6.99917 51.2759 6.9375 50.5359 6.9375 49.7959V43.7834C6.9375 37.5859 10.6992 32.2517 16.0642 29.9392C17.9142 29.1684 19.8875 28.7367 21.9842 28.7367H52.0775C53.5883 28.7367 55.0683 28.9525 56.425 29.3534C62.5917 31.2034 67.0933 36.9692 67.0933 43.7525V49.765C67.0933 50.3817 67.0625 50.9984 67.0317 51.615C66.4458 62.4067 60.4333 67.8334 49.025 67.8334",
    stroke: "#00DA71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4292 17.0508L16.0333 29.9391C10.6683 32.2516 6.90668 37.5858 6.90668 43.7833V34.7491C6.90668 25.9924 13.135 18.6849 21.4292 17.0508Z",
    stroke: "#00DA71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0933 34.7492V43.7834C67.0933 37 62.5917 31.2342 56.425 29.3842C58.0283 25.3758 58.4908 22.2309 57.72 19.61C57.6583 19.3325 57.5658 19.055 57.4425 18.8083C63.1775 21.7683 67.0933 27.8425 67.0933 34.7492Z",
    stroke: "#00DA71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d822234923cccff02d7d13fefeef8890.svg";
export { ForwardRef as ReactComponent };